import SummaryReportForm from "./SummaryReportForm";
import { TemplateWrapped } from "../../Layout";
import useSummaryReport from "./useSummaryReport";
import withSelectedPractices from "../../HOCS/withSelectedPractices/withSelectedPractices";
import { useContext } from "react";
import { AppContext } from "../../../App";
import { groupPractices } from "../Connections/connections.middleware";

const SummaryReport = () => {
  const { GetSummaryReport } = useSummaryReport();
  const appData = useContext(AppContext);
  const practices = appData.get("practices") || [];
  const clients = Object.values(groupPractices(practices)).map((client) => ({
    value: client.clientId,
    label: client.clientName,
  }));

  return (
    <>
      <TemplateWrapped title="Summary Report">
        <div
          className="panel"
          style={{ maxWidth: "80rem", width: "100%", margin: "0 auto" }}
        >
          <div className="panel-body">
            <SummaryReportForm
              GetSummaryReport={GetSummaryReport}
              clients={clients}
              practices={practices}
            />
          </div>
        </div>
      </TemplateWrapped>
    </>
  );
};

export default withSelectedPractices(SummaryReport);
